'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, useState, useEffect } from 'react';
import { TrackingStatusKeys } from 'AdsUI/lib/Constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StopPropagationWrapper from '../StopPropagationWrapper';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import UILink from 'UIComponents/link/UILink';
import TrackingStatusSurvey from './TrackingStatusSurvey';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import PortalIdParser from 'PortalIdParser';
import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink';
import { KBArticles, KBArticleSections } from 'AdsUI/lib/Constants';
import { usageTracker } from 'AdsUI/lib/usageTracker';
const SETTINGS_URL = `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`;
const SHOW_ON_HOVER = [TrackingStatusKeys.TRACKING_ENABLED, TrackingStatusKeys.TRACKING_PENDING, TrackingStatusKeys.TRACKING_LIMITED, TrackingStatusKeys.LEAD_GEN];

const NullWrapper = ({
  children
}) => children;

const TrackingStatusFooter = ({
  changeSurveyStatus,
  statusKey,
  showSettingsLink
}) => /*#__PURE__*/_jsxs(StopPropagationWrapper, {
  children: [/*#__PURE__*/_jsx(UILink, {
    onClick: () => changeSurveyStatus(true),
    className: "m-right-4",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.footer.surveyLink"
    })
  }), showSettingsLink ? /*#__PURE__*/_jsx(UILink, {
    href: SETTINGS_URL,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.footer.turnTrackingOn"
    })
  }) : statusKey === TrackingStatusKeys.ALERT ? /*#__PURE__*/_jsx(KnowledgeBaseLink, {
    kbArticle: KBArticles.AD_TRACKING,
    context: "campaign-reporting-tracking-alert",
    kbSection: KBArticleSections[KBArticles.AD_TRACKING]['TROUBLESHOOT'],
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.footer.howResolve"
    })
  }) : /*#__PURE__*/_jsx(KnowledgeBaseLink, {
    kbArticle: KBArticles.AD_TRACKING,
    context: "campaign-reporting-tracking-status",
    kbSection: KBArticleSections[KBArticles.AD_TRACKING]['HOW_IT_WORKS'],
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.footer.learnMore"
    })
  })]
});

const TrackingStatusCell = ({
  statusKey,
  use,
  children,
  statusInfo,
  showSettingsLink
}) => {
  const Wrapper = SHOW_ON_HOVER.indexOf(statusKey) > -1 ? UITableHoverContent : NullWrapper;
  const [surveyOpen, changeSurveyStatus] = useState(false);
  useEffect(() => {
    usageTracker.track('trackingStatusSurveyAction', {
      action: 'Rendered tracking status cell on screen',
      status: statusKey,
      isTrackingErrorsModal: false
    });
  }, [statusKey]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(TrackingStatusSurvey, {
      open: surveyOpen,
      status: statusKey,
      onClose: () => {
        changeSurveyStatus(false);
      },
      children: /*#__PURE__*/_jsx(UITooltip, {
        disabled: !statusInfo || surveyOpen,
        use: "longform",
        onOpenChange: e => {
          if (e.target.value) {
            usageTracker.track('trackingStatusSurveyAction', {
              action: 'Displayed tracking status (on hover)',
              status: statusKey,
              isTrackingErrorsModal: false
            });
          }
        },
        title: /*#__PURE__*/_jsxs(Fragment, {
          children: [statusInfo, /*#__PURE__*/_jsx(TrackingStatusFooter, {
            statusKey: statusKey,
            changeSurveyStatus: changeSurveyStatus,
            showSettingsLink: showSettingsLink
          })]
        }),
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("div", {
            children: children
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Wrapper, {
              children: /*#__PURE__*/_jsx(UIStatusTag, {
                use: use,
                className: "p-right-0",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `campaigns.trackingStatus.statuses.${statusKey}`
                })
              })
            })
          })]
        })
      })
    })
  });
};

TrackingStatusCell.propTypes = {
  statusKey: PropTypes.oneOf(Object.keys(TrackingStatusKeys)).isRequired,
  use: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  statusInfo: PropTypes.node,
  showSettingsLink: PropTypes.bool
};
export default TrackingStatusCell;